import { gql } from "@apollo/client";

export const signInState = {
  email: "",
  password: "",

  emailStatus: "unchecked",
  passwordStatus: "unchecked",
};

export const signInStateMange = (state, action) => {
  const inputName = action?.name;
  const value = action?.value;

  switch (inputName) {
    case "email": {
      const alphaNLenghthRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          email: value,
          emailStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          email: "",
          emailStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          email: value,
          emailStatus: "error",
        };
      }
    }
    case "password": {
      const alphaNLenghthRegex = new RegExp("^.{1,15}$");

      if (alphaNLenghthRegex.test(value)) {
        return {
          ...state,
          password: value,
          passwordStatus: "success",
        };
      } else if (!value) {
        return {
          ...state,
          password: "",
          passwordStatus: "unchecked",
        };
      } else {
        return {
          ...state,
          password: value,
          passwordStatus: "error",
        };
      }
    }

    default:
      return state;
  }
};

export const userLogin = gql`
  mutation Login($email: String!, $password: String!) {
    userLogin(email: $email, password: $password) {
      message

      id

      username

      accessToken

      access

      refreshToken

      success

      error

      webUse

      mobileUse
employeeName
      role {
        id

        role
      }

      image
      repcode
    }
  }
`;
